import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@optools/components/ui/form';
import { Input } from '@optools/components/ui/input';
import { Switch } from '@optools/components/ui/switch';
import { PipelineConfig } from '@optools/services/operator-gateway/pipeline-config/types';
import { ReactNode } from 'react';
import { useForm } from 'react-hook-form';

import { PipelineConfigFieldMapping, PipelineConfigFormValues } from './pipeline-config-form';

export interface PipelineConfigFormSectionProps {
  editMode: boolean;
  fields: (keyof PipelineConfig)[];
  form: ReturnType<typeof useForm<PipelineConfigFormValues>>;
  icon: ReactNode;
  title: string;
}

export const PipelineConfigFormSection = ({
  editMode,
  fields,
  form,
  icon,
  title,
}: PipelineConfigFormSectionProps) => {
  return (
    <section data-testid={`pipeline-config-form-${title}-section`}>
      <h2 className="mb-6 flex items-center gap-2 text-lg font-bold">
        {icon}
        {title}
      </h2>

      <div className="mb-4 grid gap-4 sm:grid-cols-2">
        {fields.map((key) => {
          return (
            <FormField
              key={key}
              control={form.control}
              name={key as keyof PipelineConfig}
              render={({ field }) => {
                const { description, disabled, label, type } =
                  PipelineConfigFieldMapping[field.name];
                return (
                  <FormItem className="flex flex-col gap-2">
                    <FormLabel>{label}</FormLabel>
                    <FormControl>
                      {type === 'switch' ? (
                        <Switch
                          checked={field.value}
                          disabled={!editMode || disabled}
                          onCheckedChange={field.onChange}
                        />
                      ) : (
                        <Input
                          {...field}
                          disabled={!editMode || disabled}
                          type={type}
                          onChange={(e) =>
                            field.onChange(type === 'number' ? +e.target.value : e.target.value)
                          }
                        />
                      )}
                    </FormControl>
                    {description && (
                      <FormDescription className="text-xs leading-5 whitespace-pre-line">
                        {description}
                      </FormDescription>
                    )}
                    <FormMessage />
                  </FormItem>
                );
              }}
            />
          );
        })}
      </div>
    </section>
  );
};
